import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SizeWarningPlaceholder = () => {
  const { t } = useTranslation('room');

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        backgroundColor: theme.room.tileBackground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      })}
    >
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.getContrastText(theme.room.tileBackground),
        })}
      >
        {t('grid.all_screens_size_warning')}
      </Typography>
    </Box>
  );
};
